import dayjs from 'dayjs';
import { dataGridPremiumColumns } from '../../utils/helper';

import { DataGridIdentifiers, DatagridPremiumUi } from '../Interface';

const AttendanceSettlementLine = ({ autocompleteOptions, values }) => {
  const columns = dataGridPremiumColumns([
    {
      field: 'userId',
      headerName: 'Név',
      sortable: false,
      type: 'string',
      renderCell: (data) => {
        const findedResourceOne = autocompleteOptions?.user.find((item) => item.value === data.row?.userId);
        return findedResourceOne?.label;
      },
    },
    {
      field: 'attendanceDate',
      headerName: 'Dátum',
      type: 'date',
      valueGetter: (_data, row) => {
        return new Date(row.attendanceDate);
      },
      renderCell: (data) => {
        return dayjs(data.row.attendanceDate).format('YYYY.MM.DD');
      },
    },
    {
      field: 'timeSpent',
      headerName: 'Idő(óra)',
      type: 'number',
      sortable: false,
    },
    {
      field: 'price',
      headerName: 'Óradíj',
      type: 'number',
      sortable: false,
    },
    {
      field: 'currencyCode',
      headerName: 'Pénznem',
      type: 'string',
      sortable: false,
    },
    {
      field: 'itemCode',
      headerName: 'Szerep',
      type: 'string',
      sortable: false,
    },
  ]);

  return (
    <div className="overflow-x-auto">
      <div className="align-middle">
        <div className="overflow-hidden shadow ring-1 ring-black ring-opacity-5 sm:rounded-lg">
          <DatagridPremiumUi
            datagridInitialState={{ density: 'compact' }}
            datagridIdentifier={DataGridIdentifiers.AttendanceSettlementLine}
            height={680}
            columns={columns}
            rows={values?.attendanceSettlementLine ?? []}
            slots={{
              toolbar: null,
            }}
            onCellDoubleClick={(_params, event) => {
              event.defaultMuiPrevented = true;
            }}
            headerFilters={false}
          />
        </div>
      </div>
    </div>
  );
};

export default AttendanceSettlementLine;
